import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { runtime } from '../../../../classes/runtime/Runtime';
export class ConditionRegistryMedia extends ConditionRegistryCategory {
    label = 'Media';
    constructor(parent) {
        super(parent);
        super.init();
    }
    fgfg3545g = () => new ConditionRegistryItem({
        label: 'Is any Medium playing',
        eval: ({ app }) => app.mediaPlayer.playerPlaying.isAnyMediumPlaying,
    });
    isMediaFilePlaying = () => new ConditionRegistryItem({
        label: 'isMediumLabelPlaying',
        eval: ({ app, condition, at }) => {
            const scopeActor = condition.local.valueOf.scope === 'local' ? at : undefined;
            return app.mediaPlayer.playerPlaying.isMediumLabelPlaying(condition.local.valueOf.availableMediaFile, { scopeActor });
        },
        params: { core: ['availableMediaFile', 'scope'] },
    });
    videoHasEnded = () => new ConditionRegistryItem({
        label: 'Video has ended',
        eval: ({ at }) => at.parent.parent instanceof runtime.class.AttachedVideo && at.parent.parent.hasEnded,
    });
    hasMediumInContext = () => new ConditionRegistryItem({
        eval: ({ at, condition }) => !!at.context.mediaContext[condition.local.valueOf.requiredMediumLabel],
        params: { core: ['requiredMediumLabel'] },
    });
    isZoomable = () => new ConditionRegistryItem({
        eval: ({ at }) => {
            if (!(at.aspect.actor instanceof runtime.class.AttachedImage))
                return false;
            const image = at.aspect.actor;
            /*
            if (runtime.runtimePermissions.hasEditFunctionality) {
              // migrate to new syntax
              if (image.core.local.valueOf.imageZoomable === 1) {
                runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                  image.localImg.trait.local.valueOf.imageZoomable = 1;
                  image.core.aspectTraitRemover.removeTraitsByKey('imageZoomable');
                });
              }
            }
    */
            if (image.localImg.trait.local.valueOf.imageZoomable === 1)
                return true;
            return false;
        },
    });
}
